import BsPageTitle from './index.vue'
export default BsPageTitle